module.exports = __webpack_public_path__ + "static/media/footer_background.fd9c5097.jpg";